import { useEffect } from 'react'
import styles from './EspecialidadesGer.module.css'
import Head from '../Helper/Head'
import TituloAssociado from '../Helper/TituloAssociado'
import { Link } from 'react-router-dom'
import { GET_ESPECIALIDADES } from '../../api'
import { useUserContext } from '../../UserContext'
import { useFileContext } from '../../useFileContext'
import Button from '../Forms/Button'

const EspecialidadesGer = () => {
  const { tokenGer, setLoading } = useUserContext();
  const { especialidadesGer, setEspecialidadesGer, setDocsGer } = useFileContext();

  useEffect(() => {
    async function getEspecialidades() {
      try {
        setLoading(true)
        const { url, options } = GET_ESPECIALIDADES(tokenGer);
        const response = await fetch(url, options);
        const { especialidades, docs } = await response.json();
        if (!response.ok) throw new Error('Erro ao tentar trazer as especialidades');
        setEspecialidadesGer(especialidades);
        setDocsGer(docs);
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    getEspecialidades();
  }, [])

  return (
    <section className={`${styles.containerPrincipal} animeLeft`}>
      <Head
        title="Área do Associado - Especialidades"
        description="Área do associado"
      />
      <div className={styles.divTitulo}>
        <TituloAssociado titulo='Relação de especialidades' />
        <Link to='nova-especialidade'>
          <Button descricao='+ nova especialidade' classe='submit' />
        </Link>
      </div>
      <div className={styles.divEspecialidades}>
        {especialidadesGer && especialidadesGer.map((item: any, index: any) => (
          <Link key={index} to={item.id.toString()}>{item.descricao}</Link>
        ))}
      </div>
    </section>
  )
}

export default EspecialidadesGer